"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@folio/stripes/components");
var CUSTPROP_TYPES = _interopRequireWildcard(require("../../constants/customProperties"));
var _validators = require("../../validators");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  REFDATA_CLASS_NAME: REFDATA,
  MULTI_REFDATA_CLASS_NAME: MULTIREFDATA,
  DECIMAL_CLASS_NAME: DECIMAL,
  INTEGER_CLASS_NAME: INTEGER,
  DATE_CLASS_NAME: DATE,
  TEXT_CLASS_NAME: TEXT
} = CUSTPROP_TYPES;
const useValueProps = function (custPropDefinition, intlKey, intlNS) {
  let labelOverrides = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  const props = {
    validate: _validators.required
  };
  switch (custPropDefinition.type) {
    case INTEGER:
    case DECIMAL:
      props.component = _components.TextField;
      props.type = 'number';
      props.validate = value => (0, _validators.invalidNumber)(value, intlKey, intlNS, labelOverrides);
      break;
    case REFDATA:
      props.component = _components.Select;
      props.dataOptions = custPropDefinition.category.values.map(rdv => ({
        label: rdv.label,
        value: rdv.id
      }));
      props.placeholder = ' ';
      break;
    case MULTIREFDATA:
      props.component = _components.Select;
      props.dataOptions = custPropDefinition.category.values.map(mrdv => ({
        label: mrdv.label,
        value: mrdv.id
      }));
      props.placeholder = ' ';
      break;
    case DATE:
      props.component = _components.Datepicker;
      props.backendDateStandard = 'YYYY-MM-DD';
      props.timeZone = 'UTC';
      props.usePortal = true;
      break;
    case TEXT:
    default:
      props.component = _components.TextField;
      break;
  }
  return props;
};
var _default = exports.default = useValueProps;